// src/components/PomodoroTimer.js
import React, { useState, useEffect } from 'react';

const PomodoroTimer = ({ workTime = 25 * 60, breakTime = 5 * 60, onPomodoroComplete }) => {
  const [seconds, setSeconds] = useState(workTime);
  const [isWorkTime, setIsWorkTime] = useState(true);

  useEffect(() => {
    if (seconds === 0) {
      if (isWorkTime) {
        setSeconds(breakTime);
      } else {
        setSeconds(workTime);
        onPomodoroComplete();
      }
      setIsWorkTime(!isWorkTime);
      return;
    }

    const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
    return () => clearTimeout(timer);
  }, [seconds, isWorkTime, workTime, breakTime, onPomodoroComplete]);

  return (
    <div className="pomodoro-timer">
      {Math.floor(seconds / 60)}:{seconds % 60 < 10 ? '0' : ''}{seconds % 60}
    </div>
  );
};

export default PomodoroTimer;
